import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import Avatar from 'react-avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrophy, faUserEdit, faTrashAlt, faSquare } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';
import Modal from 'react-modal';
import { modalStyle } from '../../styles/modal';
import * as ROUTES from '../../../constants/routes';
import ModalConfirm from '../../useful/ModalConfirm';
import { withRouter, useParams } from 'react-router-dom';

import data from '../../../constants/tournament.json';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';

const PremiumUserTournament = (props) => {

    const { user_uid } = useParams();

    const [deleting, setDeleting] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '' });
    const tournament = props.tournament;

    const { _format, _type } = data;

    const deleteTournament = () => {
        setConfirmModal({ show: false, title: '', message: '' })
        if (tournament.uid) {
            setDeleting(true);
            const deleteTournamentAdmin = props.firebase.deleteTournamentAdmin();

            const data = {
                userUid: user_uid,
                tournamentUid: tournament.uid
            }
            deleteTournamentAdmin(data)
                .then((result) => {
                    setDeleting(false);
                    if (result.data && result.data.code && result.data.code === 200) {
                        props.showModal("Info", "El torneo se eliminó con éxito");
                    } else {
                        props.showModal("Error", "No se pudo eliminar el torneo");
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setDeleting(false);
                    props.showModal("Error", "No se pudo eliminar el torneo");
                });
        }
    }

    const showConfirmModal = () => {
        setConfirmModal({ show: true, title: 'Eliminar torneo', message: 'Está seguro de eliminar el torneo: ' + tournament.title });
    }

    // const color = user && user.blocked ? '#f88b97' : '#87f892';

    const gender = (tournament.gender === "M") ? "Masculino" : (tournament.gender === "F") ? "Femenino" : "Mixto";

    return (

        <tr className="">
            {/* <td className="align-middle text-center" onClick={openTeam} scope="row" >{index}</td> */}
            <td className="align-middle text-right" >
                {tournament.finalized ?
                    <FontAwesomeIcon className="" color="#f88b97" size="lg" icon={faCalendarCheck} />
                    :
                    <FontAwesomeIcon className="" color="#90caf9" size="lg" icon={faSquare} />
                }
            </td>
            <td className="align-middle" >
                <span className="font-weight-bold">{tournament.title}</span>
            </td>
            <td className="align-middle text-center text-nowrap">{gender}</td>
            <td className="align-middle text-center text-nowrap">{_format[tournament.format] || "-"}</td>
            <td className="align-middle text-center text-nowrap">{_type[tournament.type] || "-"}</td>
            <th className="align-middle">
                <div className="nav justify-content-end">
                    {(!deleting) ?
                        <button onClick={showConfirmModal} className="btn btn btn-link text-danger p-1 m-0" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                        :
                        <Loader className="m-1"
                            type="ThreeDots"
                            color="#263238"
                            height={30}
                            width={40}
                            timeout={0} />
                    }
                </div>
            </th>

            <ModalConfirm
                data={confirmModal}
                onClose={() => setConfirmModal({ show: false, title: '', message: '' })}
                onConfirm={deleteTournament}
            />

        </tr >

    )


}

export default withRouter(withFirebase(PremiumUserTournament));
